import increaseColorPointByRatio from '../../../common/utils/increase-color-point-by-ratio';

const light = (params) => {
  const { errorColorPalette, backgroundColor } = params;
  const fallback = {
    rule: 'focusBorder.error.light',
    params,
  };
  return increaseColorPointByRatio({
    targetColor: errorColorPalette[50],
    backgroundColor,
    targetColorPalette: errorColorPalette,
    condition: (ratio) => ratio >= 1.35,
    fallback,
  });
};

export default light;
